/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React from 'react'

import { ColorsType } from 'theme/types'

import { LinkProps } from './types'

type LinkAnchorProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  accessibilityLabel?: string
  accessibilityRole?: string
  color?: LinkProps['color']
  href: string
  hoverUnderlineColor?: ColorsType
  isFocus?: boolean
  isHover?: boolean
  onPress?: React.MouseEventHandler<HTMLAnchorElement>
  testID?: string
}

export const LinkAnchor = React.forwardRef<HTMLAnchorElement, LinkAnchorProps>(
  (
    {
      accessibilityLabel,
      accessibilityRole: _accessibilityRole,
      color: _color,
      href,
      hoverUnderlineColor: _hoverUnderlineColor,
      isFocus: _isFocus,
      isHover: _isHover,
      onKeyDown,
      onPress,
      testID,
      ...props
    },
    ref
  ) => {
    const handleKeyDown: React.KeyboardEventHandler<HTMLAnchorElement> = (event) => {
      onKeyDown?.(event)
    }

    return (
      <a
        ref={ref}
        aria-label={accessibilityLabel}
        data-testid={accessibilityLabel || testID}
        href={href}
        onClick={onPress}
        onKeyDown={handleKeyDown}
        title={accessibilityLabel}
        {...props}
      />
    )
  }
)

LinkAnchor.displayName = 'LinkAnchor'
